import { render } from "./InitialsBadge.vue?vue&type=template&id=6d3226aa"
import script from "./InitialsBadge.vue?vue&type=script&lang=js"
export * from "./InitialsBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__